"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var ThreeDots = function ThreeDots() {
  return _react.default.createElement("svg", {
    width: "4px",
    height: "16px",
    viewBox: "0 0 4 16",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, _react.default.createElement("title", null, "Three Dots"), _react.default.createElement("g", {
    id: "\uD83D\uDE80-Components",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, _react.default.createElement("g", {
    id: "drawer_component",
    transform: "translate(-386.000000, -125.000000)",
    fill: "#B5BACE",
    fillRule: "nonzero"
  }, _react.default.createElement("g", {
    id: "Group-7",
    transform: "translate(78.000000, 97.000000)"
  }, _react.default.createElement("g", {
    id: "Group",
    transform: "translate(30.000000, 20.000000)"
  }, _react.default.createElement("g", {
    id: "Group-6",
    transform: "translate(264.000000, 0.000000)"
  }, _react.default.createElement("path", {
    d: "M16,12 C17.1,12 18,11.1 18,10 C18,8.9 17.1,8 16,8 C14.9,8 14,8.9 14,10 C14,11.1 14.9,12 16,12 L16,12 Z M16,14 C14.9,14 14,14.9 14,16 C14,17.1 14.9,18 16,18 C17.1,18 18,17.1 18,16 C18,14.9 17.1,14 16,14 L16,14 Z M16,20 C14.9,20 14,20.9 14,22 C14,23.1 14.9,24 16,24 C17.1,24 18,23.1 18,22 C18,20.9 17.1,20 16,20 L16,20 Z",
    id: "3-Dot"
  })))))));
};

var _default = ThreeDots;
exports.default = _default;